import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { ClinicianSearchStrategy, PersonSearchAutocompleteCustom } from "@/Common/Components/Search/PersonSearchAutocompleteCustom";
import { Person } from "@/Common/Models/Person/Person";
import { PersonDropdownItem } from "@/Common/Models/UI/Inputs/PersonDropdownItem";

interface IBannerPrintingPopupProps {
    onPrintCallback: IBannerPrintingCallback;
    onCancelCallback: () => void;

    IsForReferral: boolean;
}

interface IBannerPrintingCallback {
    (isForReferral: boolean, printingLabelFreeText: string, selectedDoctors: Immutable.List<Person>): void;
}

class BannerPrintingPopupState {
    public printingLabelFreeText: string;
    public printingLabelSelectedDoctor: Immutable.List<Person>;
    public availableClinicians: Immutable.List<Person>;

    public static Init(): BannerPrintingPopupState {
        const s = new BannerPrintingPopupState();
        s.printingLabelFreeText = "";
        s.printingLabelSelectedDoctor = Immutable.List([]);
        s.availableClinicians = Immutable.List(cacheStore.Clinicians);
        return s;
    }
}

class BannerPrintingPopup extends BaseReactComponent<IBannerPrintingPopupProps, BannerPrintingPopupState> {
    public constructor(props: IBannerPrintingPopupProps) {
        super(props);

        this.state = BannerPrintingPopupState.Init();
    }

    public render(): JSX.Element {
        let buttonDisabled = false;
        if (this.props.IsForReferral) {
            buttonDisabled = this.state.printingLabelSelectedDoctor.size === 0;
        }
        else {
            buttonDisabled = this.state.printingLabelFreeText.trim().length === 0;
        }

        return (
            <div className="popup patient-printing" style={{ overflow: "unset" }}>
                <div className="row p-header no-bottom-margin">
                    <div className="col-lg-12">
                        <a className="close" onClick={() => this.closePrintPopup()} aria-label="Close">×</a>
                        <h3 className="uppercase">{cacheStore.GetString("PrintLabelLabel")}</h3>
                    </div>
                </div>
                <div className="row no-bottom-margin">
                    <div className="col-lg-12">
                        <div className="p-body myle-form">
                            {this.props.IsForReferral === false && (
                                <div>
                                    <div><span> {cacheStore.GetString("FreeTextLabel")}: </span></div>
                                    <div>
                                        <TextboxControl
                                            value={this.state.printingLabelFreeText}
                                            onChange={val => this.mutateState(s => s.printingLabelFreeText = val)}
                                            onMountFocus={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {this.props.IsForReferral === true && (
                                <div>
                                    <div><span> {cacheStore.GetString("ProviderLabel")}: </span></div>
                                    <PersonSearchAutocompleteCustom
                                        componentId="patient_banner_print_referredBy"
                                        onSelectionCallback={(model: PersonDropdownItem) =>
                                            this.mutateState(
                                                s => s.printingLabelSelectedDoctor = Immutable.List([cacheStore.GetCliniciansPersonsByContactId(model.Item.ContactId)])
                                            )
                                        }
                                        onClearCallback={() => this.mutateState(s => s.printingLabelSelectedDoctor = Immutable.List([]))}
                                        selectedItemList={this.state.printingLabelSelectedDoctor}
                                        searchStrategy={new ClinicianSearchStrategy(this.state.availableClinicians.toArray())}
                                        closeDropDownAfterSelection={true}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="p-footer">
                            <div className="row">
                                <div className="col-lg-12 text-right">
                                    <button className="btn btn-default push-right-5" onClick={this.closePrintPopup.bind(this)}>{cacheStore.GetString("CancelLabel")}</button>
                                    <button className="btn btn-primary" disabled={buttonDisabled} onClick={this.printCustomLabel.bind(this)}>{cacheStore.GetString("PrintLabel")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private closePrintPopup(): void {
        this.props.onCancelCallback();
    }

    private printCustomLabel(): void {
        this.props.onPrintCallback(this.props.IsForReferral, this.state.printingLabelFreeText, this.state.printingLabelSelectedDoctor);
    }
}

export { BannerPrintingPopup };
